<script lang="ts">
	import ComponentCover from "@hitit/hub/src/v7/components/common/ComponentCover.svelte";
	export let slotHasPadding = false;
	export let cover = false;
	export let name = "";

</script>

<div class="container">
	<div class="image-name">
		<div class="image">
			<slot name="image" />
		</div>
		<div class="name">{name}</div>
	</div>
	<div class="slot-container" class:slotHasPadding>
		<slot />
	</div>
	{#if cover}
		<ComponentCover coverColor={'rgba(255,255,255,0.6)'} />
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		position: relative;
		width: 100%;
		flex-direction: column;
		gap: 10px;

		.image-name {
			display: flex;
			align-items: center;
			gap: 10px;

			.image {
				width: 18px;
				height: 18px;
			}

			.name {
				font-weight: 400;
				color: #6d6f76;
				font-size: 0.875rem;
			}
		}
		.slot-container {
			width: 100%;
			box-sizing: border-box;

			&.slotHasPadding {
				padding-left: 28px;
			}
		}
	}

	@include DesktopSize {
		.container {
			.image-name {
				.image {
					width: 28px;
					height: 28px;
				}
				.name {
					font-size: 1.25rem;
				}
			}

			.slot-container {
				&.slotHasPadding {
					padding-left: 38px;
				}
			}
		}
	}

</style>
